import {
	getCreditType
} from '../config/settings.js';

const getTradeIn = ({ eventData, eventName, eventAction }) => {
	if (
		eventName === 'DR_TRADEIN_CHANGED' ||
		eventData?.asc?.flow_name === 'DR_TRADEIN_CHANGED' ||
		(eventName === 'DR_TRADEIN_ESTIMATE_RECEIVED' && eventAction === 'DR_TRADEIN_ACTION')
	) {
		const { value, amountOwed, condition } = eventData;

		return {
			value,
			amountOwed,
			condition,
		};
	}

	return null;
};

export const mapAMDDataToWallet = (eventObj) => {
	const { eventData } = eventObj;
	const {
		annualMiles: leaseMileageRange,
		downPayment,
		financeTermMonths: loanTerm,
		leaseTermMonths: leaseTerm,
		creditScoreHigh,
		creditScoreLow,
		defaultOfferType,
		asc,
		dealType
	} = eventData;

	const tradeIn = getTradeIn(eventObj);
	const creditType = getCreditType(creditScoreLow, creditScoreHigh);
	const newDealType = dealType || defaultOfferType || asc?.item_payment || null;
	const paymentOption = dealType;

	const buildWalletObj = {
		...(leaseMileageRange && { leaseMileageRange }),
		...(downPayment && { downPayment }),
		...(loanTerm && { loanTerm }),
		...(leaseTerm && { leaseTerm }),
		...(creditScoreLow && { creditType }),
		...(newDealType && { dealType: newDealType }),
		...(paymentOption && { paymentOption }),
		...(tradeIn && { tradeIn })
	};

	return { 
		payload: buildWalletObj
	};
};
